import React from 'react'

export default function Box1() {
  return (
    <div className='col-4 w-100'>
         <div className="custom-roadmap-box-container rounded-3 p-3">
                  <h1>Quality Control Management Features</h1>
                  <hr/>
                  <p>Our journey began with the introduction of our aircraft simulator management system, featuring robust quality control management tools to ensure precision and reliability.</p>
                  
                </div>
    </div>
  )
}
